import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { CreatePlaylistFolderDocument } from './create.generated';

export const useCreatePlaylistFolder = (
  options: ApiOptions<typeof CreatePlaylistFolderDocument> = {},
) => {
  const { t } = useTranslation();

  return useMutation(CreatePlaylistFolderDocument, {
    ...useNotifications(CreatePlaylistFolderDocument, {
      failure: (error) => error.message || t('api.common.error_generic'),
      success: t('api.playlist_folders.create_success'),
    }),
    ...options,
  });
};
